export enum NewsletterSubscribeFormTestIds {
  main = 'newsletter-subscribe-container',
  header = 'newsletter-subscribe-header',
  form = 'newsletter-subscribe-form',
  modallink = 'newsletter-subscribe-modallink',
  button = 'newsletter-subscribe-button',
  page1 = 'newsletter-subscribe-page1',
  page2 = 'newsletter-subscribe-page2',
  page3 = 'newsletter-subscribe-page3',
  page4 = 'newsletter-subscribe-page4',
}
